import React from "react";
import { Button, Divider, Drawer, DrawerProps, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { Flex } from "css/styles";
import { CheckboxGroup } from "components/CheckboxGroup";

export type FilterOption = {
  title: string;
  value: string[];
  onChange: (value: string[]) => unknown;
  options: {
    value: string;
    label: string | JSX.Element;
  }[];
  clearAll?: { allow: boolean };
  selectAll?: { allow: boolean; label: string };
};

type FiltersDrawerProps = {
  onClose: (e: React.MouseEventHandler<HTMLElement>) => unknown;
  filterOptions: FilterOption[];
} & DrawerProps;

export const FiltersDrawer = (props: FiltersDrawerProps) => {
  const { onClose, filterOptions, ...drawerProps } = props;
  return (
    <Drawer
      title={
        <Flex>
          <Typography.Text strong>Filters</Typography.Text>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={(e) => onClose(e as unknown as React.MouseEventHandler<HTMLElement>)}
          />
        </Flex>
      }
      onClose={onClose}
      placement="right"
      closable={false}
      width={350}
      {...drawerProps}
    >
      {filterOptions.map(({ title, value, onChange, options, clearAll, selectAll }, index, array) => {
        const isLastItem = index === array.length - 1;
        return (
          <>
            <CheckboxGroup
              key={title}
              title={title}
              value={value}
              onChange={onChange}
              options={options}
              selectAll={selectAll}
              clearAll={clearAll}
            />
            {!isLastItem && <Divider />}
          </>
        );
      })}
    </Drawer>
  );
};
